function Home() {
  return (
    <>
      <div className=" text-center home">
        <h1 className="text-light">What's life without music?</h1>
        <h3>It's food for the soul.</h3>
      </div>
    </>
  );
}
export default Home;
